<template>
  <div>
    <div class="pa-4 elevation-1" style="border-radius: 4px">
      <p>내 상태 알리기</p>
      <select-status @change="onChangeSelectStatus"></select-status>
      <text-update
        @checkbox="onClickTextUpdateCheckbox"
        @button="onClickTextUpdateButton"
        @delay-button="onClickTextUpdateButton"
      ></text-update>
    </div>

    <div class="pa-4 elevation-1 mt-2" style="border-radius: 4px">
      <p>뇌 구조 훔쳐보기</p>
      <v-btn small depressed color="primary" class="mt-2" @click="onClickBrainPeek">🧠 5초 보여주기</v-btn>
    </div>
  </div>
</template>

<script>
import { getVirtupetPubSocket } from "@/domain/stream/pub/VirtupetPubSocket";
import SelectStatus from "../components/SelectStatus.vue";
import TextUpdate from "../components/TextUpdate.vue";

export default {
  components: { TextUpdate, SelectStatus },
  props: {
    petId: { type: String, default: null }, // 제어할 펫 (pub 라우팅 키)
  },
  methods: {
    onChangeSelectStatus(isVisible, userInput) {
      getVirtupetPubSocket(this.petId).requestUpdateVisibility(
        "outerFacade#streamer-status-text-layer",
        isVisible,
        userInput,
      );
    },
    onClickTextUpdateCheckbox(isVisible, userInput) {
      getVirtupetPubSocket(this.petId).requestUpdateVisibility("outerFacade#streamer-message", isVisible, userInput);
    },
    onClickTextUpdateButton(isVisible, userInput) {
      getVirtupetPubSocket(this.petId).requestUpdateVisibility("outerFacade#streamer-message", isVisible, userInput);
    },
    // 뇌 구조 훔쳐보기 — 오버레이 BroadcastBox가 세션룰 워드클라우드를 5초 표시(자체 타이머)
    onClickBrainPeek() {
      getVirtupetPubSocket(this.petId).requestUpdateVisibility("outerFacade#brain-cloud", true);
    },
  },
};
</script>

<style scoped>
p {
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: #333; /* 라이트 기준 */
}
/* 다크 대응색 (.theme--dark는 v-app 조상 클래스 — scoped여도 매칭됨) */
.theme--dark p {
  color: #d1d5db;
}
</style>
